import React, {useState,useRef} from 'react';
import '../../styles/style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import BASE from "../../config";
import ReCAPTCHA from "react-google-recaptcha";


const Contact_Us = () => {

  const [fullName,setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [email,setEmail] = useState("");
  const [message,setMessage] = useState("");

  const recaptchaRef = useRef(null);
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  const [emailMessage,setEmailMessage] = useState("");

 const handleNameChange=(event)=>{
   setFullName(event.target.value);
   setErrors('');
  }
  const handlePhoneChange=(event)=>{
    setPhone(event.target.value);
    setErrors('');
  }
  const handleEmailChange=(event)=>{
    setEmail(event.target.value);
    setErrors('');
  }
  const handleMessageChange=(event)=>{
    setMessage(event.target.value);
    setErrors('')
  }

  const [loading, setLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);


  const [errors,setErrors] = useState("");

  const sendEmail =(e) =>{
    e.preventDefault();

    setLoading(true);

    const emailFormData ={
      fullName,
      phone,
      email,
      message,
      recaptcha: recaptchaToken,

    };
    // console.log(emailFormData)


    axios.post(BASE.BASE_API_URL+'/api/contact-us',emailFormData).then(res =>{
// console.log(res);
//       console.log("Mail Sent Successfully");
      setEmailMessage(res.data.email_message)

      // console.log('Email Sent Successfully');

      setFullName('');
      setPhone('');
      setEmail('');
      setMessage('');
      setLoading(false);
      setFormSubmitted(true);
      setErrors("");
    }).catch(error => {
          if (error.response && error.response.status === 422) {
            const fieldErrors = error.response.data.errors;
            setErrors({
              fullName: fieldErrors.fullName?.[0] || '',
              phone: fieldErrors.phone?.[0] || '',
              email: fieldErrors.email?.[0] || '',
              message: fieldErrors.message?.[0] || '',
              recaptcha: fieldErrors.recaptcha?.[0] || '',
            });
          }
        }).finally(() => {
        setLoading(false);

      });


  }

  return(
      <div className="Contact_Us_Content">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="Contact_Us_Content_Left">
                <h1>Contact us</h1>
                <p>Need some help, or have a question? We are happy to talk to you in person. Use the form below to email
                  us or request a callback.</p>
                <form onSubmit={sendEmail}>
                  <div className="row mt-4">
                    <div className="col">
                      <input value={fullName} onChange={handleNameChange} className="form-control" placeholder="Full Name" type="text" name="fullName" />
                      {errors.fullName && <span style={{ color: 'red' }}>{errors.fullName}</span>}
                    </div>
                    <div className="col">
                      <input value={phone} onChange={handlePhoneChange} className="form-control" placeholder="Phone Number" type="text" name="phone" />
                      {errors.phone && <span style={{ color: 'red' }}>{errors.phone}</span>}
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="col">
                      <input value={email} onChange={handleEmailChange} className="form-control" placeholder="Email Address" type="text" name="email" />
                      {errors.email && <span style={{ color: 'red' }}>{errors.email}</span>}
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="col">
                      <textarea value={message} onChange={handleMessageChange} name="message" rows="8" col="10" placeholder="Optional Message"></textarea>
                      {errors.message && <span style={{ color: 'red' }}>{errors.message}</span>}
                    </div>
                  </div>
                  <div className="row mt-5">
                    <div className="col">
                      <div className="form-check">
                        <input className="form-check-input" id="check1" type="checkbox" value="something" name="option1" />
                        <label className="form-check-label">Send me emails with news, special offers, discounts and promotions</label>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-5">
                    <div className="col">
                      <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey={BASE.REACT_APP_RECAPTCHA_SITE}
                          onChange={handleRecaptchaChange}
                      />
                      {errors.recaptcha && <span style={{ color: 'red' }}>{errors.recaptcha}</span>}
                    </div>
                    <div className="col">
                      <button
                          type="submit"
                          className="btn  btn-primary w-50 me-2"
                          disabled={loading}
                      >
                        {loading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              Sending...
                            </>
                        )  : (
                            "Send"
                        )}
                      </button>
                      {/*<button >Send</button>*/}
                    </div>
                  </div>
                  {/*<p className="email-submition-message">{emailMessage}</p>*/}
                  <p className={`submition-message ${emailMessage ? "active-message" : ""}`}>
                    {emailMessage}
                  </p>
                </form>



              </div>
            </div>
            <div className="col-md-4">
              <div className='Contact_Us_Content_Right'>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3182.761017196313!2d-8.03516741890313!3d37.08699840040061!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab35655a0e9cb%3A0x50b38b8c7a715cb0!2sSunbound%20Villas!5e0!3m2!1sen!2s!4v1738586210632!5m2!1sen!2s" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                <ul className='border_padding'>
                  <li>PORTUGAL</li>
                  <li><div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                    <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: "#F6897A", marginRight: "10px" }} />
                    <span>Sunbound Villas Rua Vale Formoso, Edifcio Poço Novo Loja nr 12 8135-148, Almancil</span>
                  </div></li>
                  <li><div style={{ display: "flex", alignItems: "center" }}>
                    <FontAwesomeIcon icon={faPhone} style={{ color: "#F6897A", marginRight: "10px" }} />
                    <span>00 351 289099457</span>
                  </div></li>
                </ul>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2385.855249262783!2d-6.2153561236803!3d53.274213172268496!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x486709b88ed01a6f%3A0xf2d5fb1ae3dda3bb!2sSunbound%20Villas!5e0!3m2!1sen!2s!4v1738586142883!5m2!1sen!2s" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                <ul className='border_padding'>
                  <li>IRELAND</li>
                  <li><div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                    <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: "#F6897A", marginRight: "10px" }} />
                    <span>Sunbound Villas 37 Heather Road, Sandyford Business District, Dublin 18</span>
                  </div></li>
                  <li><div style={{ display: "flex", alignItems: "center" }}>
                    <FontAwesomeIcon icon={faPhone} style={{ color: "#F6897A", marginRight: "10px" }} />
                    <span>00 353 1 2130701</span>
                  </div></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}

export default Contact_Us;